/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AIConnection
 */
export interface AIConnection {
    /**
     * 
     * @type {number}
     * @memberof AIConnection
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof AIConnection
     */
    name: string;
}

export function AIConnectionFromJSON(json: any): AIConnection {
    return AIConnectionFromJSONTyped(json, false);
}

export function AIConnectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): AIConnection {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function AIConnectionToJSON(value?: AIConnection | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}


